import type { FunctionComponent } from 'react';

import { useApplicationContext } from '~/shared/context/use-application-context';
import { useTranslate } from '~/shared/context/use-translate';
import { Morph } from '~/ui/animations/morph/Morph';
import { DropdownMenuItem } from '~/ui/core/dropdown-menu/DropdownMenu';
import { IconEye } from '~/ui/core/icons';

import { useUnwatchItem } from '../api/use-unwatch-item';
import { useWatchItem } from '../api/use-watch-item';
import { useIsWatched } from '../api/use-watches';

export const WatchMenuItem: FunctionComponent<{ readonly itemId: string }> = ({ itemId }) => {
    const { applicationState } = useApplicationContext();
    const translate = useTranslate();
    const isWatched = useIsWatched(itemId);
    const { mutate: watchItem } = useWatchItem();
    const { mutate: unwatchItem } = useUnwatchItem();
    const watchStateKey = isWatched ? 'unwatch' : 'watch';

    if (!applicationState.featureFlagService.isFeatureFlagEnabled('new-dashboard')) {
        return null;
    }

    const handleSelect = (event: Event): void => {
        event.preventDefault();

        if (isWatched) {
            unwatchItem(itemId);

            return;
        }

        watchItem(itemId);
    };

    return (
        <DropdownMenuItem onSelect={handleSelect}>
            <IconEye size={16} />
            <Morph align="start" direction="vertical" stateKey={watchStateKey}>
                {translate(isWatched ? 'common.unwatch' : 'common.watch')}
            </Morph>
        </DropdownMenuItem>
    );
};
